import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SocketService } from './core/services/socket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Restore Hair Clinic';

  constructor(private router: Router, private socketSvc: SocketService) { }

  ngOnInit(): void {
    const token = localStorage.getItem('authToken');
    if (token) this.socketSvc.connect(token);
  }
}
